import Link from '@/lib/nav/link';
import { Logo } from '@/components/branding/Logo';

export function GuideAuthLoading() {
  return (
    <div className="min-h-screen bg-ivory">
      <header className="border-b border-black/8 bg-white/85 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-6 py-4">
          <Link href="/" className="inline-flex items-center" aria-label="Roam Together home">
            <Logo variant="full" width={170} height={62} className="h-10 w-auto" priority />
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10 md:py-14">
        <div className="space-y-6 text-center" role="status" aria-label="Loading guide">
          <p className="text-[11px] font-black uppercase tracking-[0.12em] text-primary">
            Kiersten&apos;s free guides
          </p>
          <div className="mx-auto h-10 w-3/4 max-w-md animate-pulse rounded-xl bg-black/[0.06]" />
          <div className="mx-auto h-5 w-2/3 max-w-sm animate-pulse rounded-lg bg-black/[0.05]" />
          <div className="mx-auto mt-8 space-y-3 text-left">
            <div className="h-4 w-full animate-pulse rounded bg-black/[0.05]" />
            <div className="h-4 w-[92%] animate-pulse rounded bg-black/[0.05]" />
            <div className="h-4 w-[88%] animate-pulse rounded bg-black/[0.05]" />
            <div className="h-4 w-[95%] animate-pulse rounded bg-black/[0.05]" />
          </div>
          <span className="sr-only">Loading…</span>
        </div>
      </main>
    </div>
  );
}
